import { render } from "./CancelPage.vue?vue&type=template&id=518f322a"
import script from "./CancelPage.vue?vue&type=script&lang=js"
export * from "./CancelPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__